/**
 * @generated SignedSource<<b66d1fd19c93dedf89ada7288cc11bc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type useInitEventMeta_event$data = {
  readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
  readonly capacity: number | null | undefined;
  readonly clientEligibleSignUpWindows: ReadonlyArray<{
    readonly cancelDeadlineAt: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly hasWaitlist: boolean;
  readonly id: string;
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly spotsAvailable: number | null | undefined;
  readonly " $fragmentType": "useInitEventMeta_event";
};
export type useInitEventMeta_event$key = {
  readonly " $data"?: useInitEventMeta_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"useInitEventMeta_event">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useInitEventMeta_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasWaitlist",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "accessStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "EventSignUpWindow",
      "kind": "LinkedField",
      "name": "clientEligibleSignUpWindows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cancelDeadlineAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "cacaed78f23dd6bf257d0dd761868881";

export default node;
